import * as React from "react";
import { Reducer } from "./Reducer";
import { createControllerView } from "strikejs-react";
import {
  ContentManagerProps,
  inContentManagerState,
  inContentManagerInitialState,
  ContentManagerInitState
} from "./StateAndProps";
import { ACTIONS, TYPES } from "./Actions";
import { RES_URL, IS_SAFARI } from "../../config";
import { ACTIONS as APP_ACTIONS } from "../App/Actions";
import * as _ from "lodash";
import { ProtanopiaPage } from "../../pages/ProtanopiaPage/ProtanopiaPage";
import { TritanopiaPage } from "../../pages/TritanopiaPage/TritanopiaPage";
import { DeuteranopiaPage } from "../../pages/DeuteranopiaPage/DeuteranopiaPage";
import { MainPage } from "../../pages/MainPage/MainPage";

export const STATE_KEY = "contentManager";

class ContentManagerController extends React.Component<
  ContentManagerProps,
  inContentManagerState
> {
  mainPageEl: MainPage;
  constructor(props) {
    super(props);
    this.state = inContentManagerInitialState;
  }

  componentDidMount() {
    let DS = this.props.dataService;
    if (DS.isDataLoaded) {
      this.props.store.dispatch(APP_ACTIONS.DATA_LOADED(DS.getData()));
    } else {
      DS.load().then(e => {
        this.props.store.dispatch(APP_ACTIONS.DATA_LOADED(e));
      });
    }
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => this.forceUpdate();

  getContent = (data): JSX.Element => {
    if (this.props.routeParams.key) {
      return (
        <MainPage
          key={this.props.routeParams.key}
          route={this.props.routeParams.key}
          locale={this.props.data.locale}
          data={data}
          keyData={_.keyBy(data, "id")}
        />
      );
    } else {
      switch (this.props.routeParams.route) {
        case "protanopia":
          return <ProtanopiaPage locale={this.props.data.locale} />;
        case "deuteranopia":
          return <DeuteranopiaPage locale={this.props.data.locale} />;
        case "tritanopia":
          return <TritanopiaPage locale={this.props.data.locale} />;
      }
    }
  };

  render() {
    let state = this.state,
      props = this.props,
      locale = props.data.locale;

    const data = props.data[this.props.routeParams.route];

    return (
      <div className="content-manager main-content">
        {this.getContent(data)}
      </div>
    );
  }
}

export const ContentManager = createControllerView({
  reducer: Reducer,
  propsToPropagate: ["dataService"],
  initialState: ContentManagerInitState,
  stateKey: STATE_KEY,
  component: (function() {
    return ContentManagerController;
  })()
});



// WEBPACK FOOTER //
// ./src/controllers/ContentManager/ContentManager.tsx